import { render } from "./VertexProposal.vue?vue&type=template&id=11b6fd44&scoped=true"
import script from "./VertexProposal.vue?vue&type=script&lang=js"
export * from "./VertexProposal.vue?vue&type=script&lang=js"

import "./VertexProposal.vue?vue&type=style&index=0&id=11b6fd44&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b6fd44"]])

export default __exports__